export enum AppModules {
  COLLABORATION = 'COLLABORATION',
  PLANNING = 'PLANNING',
  SOLAINTEL = 'SOLAINTEL',
  WORK_TIME_REPORTING = 'WORK_TIME_REPORTING',
  UI2 = 'UI2',
  WORKSPACE = 'WORKSPACE',
  BRANDING = 'BRANDING',
}

export enum PathModules {
  '/portal/my-workspace' = 'WORKSPACE',
}
